export const getReportsListSelector = state => state?.agencies?.get('reports')
